import i18n from 'i18next';

import { mfeTranslations } from './index';

/**
 * Registers the texts of the microfrontend host views. They ship in the bundle instead of being
 * fetched, because the error view has to render precisely when the network is failing.
 */
export const registerMfeTranslations = (): void => {
  if (!i18n.addResourceBundle) return;

  Object.entries(mfeTranslations).forEach(([language, resources]) => {
    i18n.addResourceBundle(language, 'mfe', resources, true, true);
  });
};
